export default __webpack_public_path__ + "static/media/virtualCard.8372e4c6.png";